export default function parseVendorConsent(config) {
    let newVendorConsent = {};
    let newObjectConsent = {};
    let newSpecialFeatureOptins = {};
    let newConsentModeConsent = {};
    let newPurposeConsent = {};
    let newPurposeLegitimateInterest = {};

    if (config.vendorList) {
        for (let index = 0; index < config.vendorList.vendors.length; index++) {
            let vendorId = config.vendorList.vendors[index].id;
            if (config.vendorList.vendors[index].legIntPurposes.length) {
                if (typeof config.static?.objectConsent?.[vendorId] === 'boolean') {
                    newObjectConsent[vendorId] = config.static.objectConsent[vendorId];
                } else {
                    newObjectConsent[vendorId] = config.defaultObjectConsent === false ? config.defaultObjectConsent : true;
                }
            }

            if (typeof config.static?.vendorConsent?.[vendorId] === 'boolean') {
                newVendorConsent[vendorId] = config.static.vendorConsent[vendorId];
            } else {
                newVendorConsent[vendorId] = config.defaultConsent === false ? config.defaultConsent : true;
            }
        }

        for (let index = 0; index < config.vendorList.specialFeatures.length; index++) {
            let specialFeaturesId = config.vendorList.specialFeatures[index].id;

            if (typeof config.static?.specialFeatureOptins?.[specialFeaturesId] === 'boolean') {
                newSpecialFeatureOptins[specialFeaturesId] = config.static.specialFeatureOptins[specialFeaturesId];
            } else {
                newSpecialFeatureOptins[specialFeaturesId] = config.defaultConsent === false ? config.defaultConsent : true;
            }
        }

        // consentMODE
        for (let index = 0; index < config.vendorList.consentMode.length; index++) {
            let consentMode = config.vendorList.consentMode[index].id;
            if (typeof config.static?.newConsentModeConsent?.[consentMode] === 'boolean') {
                newConsentModeConsent[consentMode] = config.static.newConsentModeConsent[consentMode];
            } else {
                newConsentModeConsent[consentMode] = config.defaultConsent === false ? config.defaultConsent : true;
            }
        }

        for (let index = 0; index < config.vendorList.purposes.length; index++) {
            let purposeId = config.vendorList.purposes[index].id;

            if (typeof config.static?.purposeConsent?.[purposeId] === 'boolean') {
                newPurposeConsent[purposeId] = config.static.purposeConsent[purposeId];
            } else {
                newPurposeConsent[purposeId] = config.defaultConsent === false ? config.defaultConsent : true;
            }

            if (config.static?.purposeLegitimateInterest?.[purposeId] === 'boolean') {
                newPurposeLegitimateInterest[purposeId] = config.static.purposeLegitimateInterest[purposeId];
            } else {
                newPurposeLegitimateInterest[purposeId] = config.defaultObjectConsent === false ? config.defaultObjectConsent : true;
            }
        }
    }

    return {
        vendorConsent: newVendorConsent,
        objectConsent: newObjectConsent,
        specialFeatureOptins: newSpecialFeatureOptins,
        consentMode: newConsentModeConsent,
        purposeConsent: newPurposeConsent,
        purposeLegitimateInterest: newPurposeLegitimateInterest
    };
}